// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// Define a service using a base URL and expected endpoints
export const transactionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllTransactions: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `transactions?${queryString}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 300, // Cache for 5 minutes
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllTransactionsQuery } = transactionApi;
